import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Observable, map } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ActionsModalUiComponent } from '../../shared/components/simple/actions-modal-ui/actions-modal.ui.component';

export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean;
}

@Injectable({
  providedIn: 'root',
})
export class UnsavedChangesGuard implements CanDeactivate<HasUnsavedChanges> {
  constructor(
    private matDialog: MatDialog,
    private translate: TranslateService,
  ) {}

  canDeactivate(
    component: HasUnsavedChanges,
    _current: ActivatedRouteSnapshot,
    _currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot,
  ): Observable<boolean> | boolean {
    if (!component.hasUnsavedChanges()) return true;
    if (nextState?.url?.startsWith('/auth/')) {
      this.matDialog.closeAll();
      return true;
    }

    const dialogRef = this.matDialog.open(ActionsModalUiComponent, {
      data: {
        title: this.translate.instant('UnsavedChangesTitle'),
        description: this.translate.instant('UnsavedChangesDescription'),
        cancelText: this.translate.instant('UnsavedChangesStay'),
        confirmText: this.translate.instant('UnsavedChangesLeave'),
      },
    });

    return dialogRef.afterClosed().pipe(map((result) => !!result));
  }
}
